// extracted by mini-css-extract-plugin
export default {"div":"EditableTableFieldNoOnBlurUpdate_div__9fck9","input":"EditableTableFieldNoOnBlurUpdate_input__DjZmX"};